import React, { useState, useEffect, useContext } from 'react'
import DateService from 'live/services/date'
import { DashboardContext } from 'live/context/dashboard'
import Authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'
import { DataQualityAnnotationExtra, ForceExclusionAnnotationExtra } from '../types'
import api from '../../api'
import { HelpBlock } from 'react-bootstrap'
import { __SOURCE_METADATA__ } from "../commom"
import { ContainerBody, Footer, FromDatePicker, Header, Selector, ToDatePicker, getUnixFromDateAndTime, getWellName, makeHisotry } from '../commom'
import { FORCE_EXCLUSION_TYPE_KEY, metadataOptionsKeyTitle } from './MetadataOptions'

function makeExtra(form, wellName) {
    const extra: ForceExclusionAnnotationExtra = {
        authorId: Authorization.user.id,
        author: Authorization.user.username,
        wellbore_name: wellName,
        [FORCE_EXCLUSION_TYPE_KEY]: "",
        metadata_type: FORCE_EXCLUSION_TYPE_KEY,
        reason: form.reason
    }

    return extra
}

export default function ({ mode = 'temporal', event, onHide, ...props }) {
    if (mode !== 'temporal')
        return

    const beginValue = DateService.getMoment(parseInt(event.begin))
    const endValue = event.end !== null && event.end !== undefined ? DateService.getMoment(parseInt(event.end)) : null
    const { state, params, ...context } = useContext(DashboardContext)
    const [errors, setErrors] = useState({})
    const [options, setOptions] = useState([])
    const [colors, setColors] = useState({})
    const [form, setForm] = useState({
        reason: event?.extra?.reason ?? '',
        fromDate: beginValue,
        fromTime: beginValue.format('HH:mm:ss'),
        toDate: endValue ?? null,
        toTime: !!endValue ? endValue.format('HH:mm:ss') : null
    })
    const wellName = getWellName(params.filter)

    function onSubmit() {
        const payload = {
            ...event,
            extra: makeExtra(form, wellName),
            uid: (event && event.uid) || undefined,
            begin: getUnixFromDateAndTime(form.fromDate, form.fromTime),
            end: !!form.toDate && !!form.toTime ? getUnixFromDateAndTime(form.toDate, form.toTime) : null,
            __src: __SOURCE_METADATA__,
            __color: event?.__color ?? 'red',
            message: `Forced exclusion\nReason: ${form.reason}`,
            activeDashboardFilters: props.activeDashboardFilters,
        }

        payload['extra']['history'] = makeHisotry(event, payload)

        api.createAnnotation(payload).then(e => {
            onHide()
        })
    }

    return <ContainerBody>
        {/* <div className="live-annotation__title">FORCE EXCLUSION</div> */}
        <div className="timeline__form">
            <FromDatePicker beginValue={beginValue} form={form} setForm={setForm} errors={errors} />
            <ToDatePicker endValue={endValue} form={form} setForm={setForm} errors={errors} />
            <div className="timeline__form__message">
                <label style={{ color: 'var(--gray-900)' }} htmlFor="timeline-to-date-picker">
                    {i18n('Reason')}:
                </label>
                <textarea
                    onMouseDown={e => e.stopPropagation()}
                    className="form-control"
                    value={form.reason}
                    onChange={e => {
                        setForm({ ...form, reason: e.target.value })
                    }}
                />

                {!form.reason ? (
                    <div>
                        <HelpBlock bsClass="text-danger">{i18n('This is a required field.')}</HelpBlock>
                    </div>
                ) : null}
            </div>
            <br />
            <Footer form={form} onSubmit={onSubmit} disabled={!form.reason} onHide={onHide} />
        </div>
    </ContainerBody>
}